import { UserTagEnum } from '@/views/NewLive/typings';

export interface UserTagStyleConfig {
  label: string;
  color: string;
  borderColor: string;
}

const userTagMap = new Map<UserTagEnum, UserTagStyleConfig>([
  [
    UserTagEnum.RETURNING,
    {
      label: '回流用户',
      color: 'rgba(114, 168, 255, 1)',
      borderColor: 'rgba(114, 168, 255, 0.8)'
    }
  ],
  [
    UserTagEnum.CORE,
    {
      label: '核心用户',
      color: 'rgba(255, 109, 109, 1)',
      borderColor: 'rgba(255, 109, 109, 0.8)'
    }
  ],
  [
    UserTagEnum.POTENTIAL,
    {
      label: '潜力用户',
      color: 'rgba(232, 184, 74, 1)',
      borderColor: 'rgba(232, 184, 74, 0.8)'
    }
  ],
  [
    UserTagEnum.PAID,
    {
      label: '付费用户',
      color: 'rgba(185, 140, 255, 1)',
      borderColor: 'rgba(185, 140, 255, 0.8)'
    }
  ],
  [
    UserTagEnum.NORMAL,
    {
      label: '普通用户',
      color: 'rgba(154, 163, 178, 1)',
      borderColor: 'rgba(154, 163, 178, 0.8)'
    }
  ],
  [
    UserTagEnum.NEW,
    {
      label: '新用户',
      color: 'rgba(79, 209, 142, 1)',
      borderColor: 'rgba(79, 209, 142, 0.8)'
    }
  ]
]);

/** 根据标签枚举值查询样式配置 */
export function getUserTagConfig(userTagType?: UserTagEnum): UserTagStyleConfig | undefined {
  if (!userTagType) return undefined;
  return userTagMap.get(userTagType);
}
